import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

import { HttpService, NotificationService, TmsWebBaseEditCreateService } from 'tms-lib';
import { ShipperInterfaceHeader, ShipperResponse } from '../../../models';

@Injectable({
  providedIn: 'root',
})
export class ShipperInterfaceHeaderService extends TmsWebBaseEditCreateService<
  ShipperInterfaceHeader,
  ShipperInterfaceHeader
> {
  public refreshDetails = new Subject<void>();

  constructor(
    protected httpService: HttpService,
    protected notificationService: NotificationService,
  ) {
    super('ShipperInterfaceHeader', $localize`Shipper Interface Header`, httpService, notificationService);
  }

  bookShipping(id: string, shippingNotes: string): Observable<ShipperResponse> {
    return this.httpService.post<ShipperResponse>(`${this.apiUrl}/BookShipping`, { id, shippingNotes });
  }

  reprintLabel(id: string, shipperInterfaceHeaderId: string): Observable<ShipperResponse> {
    return this.httpService.post<ShipperResponse>(`${this.apiUrl}/ReprintLabel`, {
      id,
      shipperInterfaceHeaderId,
    });
  }

  changeShipper(shipperId: string, documentId: string): Observable<ShipperResponse> {
    return this.httpService.post<ShipperResponse>(`${this.apiUrl}/ChangeShipper`, { shipperId, documentId });
  }
}
